/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';

import { IFinancingOfferFormatted } from '../Utilities/select-financing-offer';

/**
 * FinancingOfferState Input Action
 */

export class FinancingOfferStateInput implements Msdyn365.IActionInput {
    //   Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `FinancingOfferState`;
    public getCacheObjectType = () => 'FinancingOfferState';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

//   Create a data model here or import one to capture the response of the action
export interface IFinancingOfferStateData {
    isOpen: boolean;
    totalPrice?: number;
    financingOffer?: IFinancingOfferFormatted;
}

/**
 *   Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new FinancingOfferStateInput();
};

/**
 *   Use this function to call your action and process the results as needed
 */
async function action(input: FinancingOfferStateInput, ctx: Msdyn365.IActionContext): Promise<IFinancingOfferStateData> {
    return { isOpen: false };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IFinancingOfferStateData>>action,
    id: 'FinancingOfferState',
    input: createInput
});
